<script setup>
  import {inject} from "vue";

  import {useForm} from "@inertiajs/vue3";
  import {confirmationLabels} from "@pages/Patients/Enums/Enums.js";
  import {MedCheckbox, MedFormField, MedLabel} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "ComponentPatientReleaseConfidentiality",
  });

  const props = defineProps({
    patient: {
      type: Object,
      required: true,
    },
  });

  const broadcast = inject("$broadcast");

  const form = useForm({
    accepted: props.patient.releasefromconfidentialityconfirmed !== null,
    subject: "releasefromconfidentialityconfirmed",
  });

  function save() {
    form
      .transform((data) => ({
        type: data.accepted ? "accepted" : "rejected",
        subject: data.subject,
      }))
      .post(route("confirmations.store", {patient: props.patient.id}), {
        preserveScroll: true,
        preserveState: true,
        only: ["patient"],
        onSuccess: () => {
          broadcast.patient.postMessage(props.patient.id, {action: "reload.patient"});
        },
      });
  }
</script>

<template>
  <div>
    <p class="leading-snug">
      Bitte beachten Sie, dass eine Kommunikation nur auf Basis einer vorliegenden Schweige&shy;pflicht&shy;entbindung
      vorgenommen werden kann.
    </p>

    <div class="mt-2">
      <MedFormField orientation="horizontal">
        <MedCheckbox
          v-model="form.accepted"
          variant="primary"
          :data-test="getTestId('patient-release-confidentiality-checkbox')"
          @change="save()"
        />

        <MedLabel>{{ confirmationLabels["releasefromconfidentialityconfirmed"] }} liegt vor</MedLabel>
      </MedFormField>
    </div>
  </div>
</template>
